import { render } from "./clsBtnV2.vue?vue&type=template&id=78a06c8e&scoped=true"
import script from "./clsBtnV2.vue?vue&type=script&lang=js"
export * from "./clsBtnV2.vue?vue&type=script&lang=js"

import "./clsBtnV2.vue?vue&type=style&index=0&id=78a06c8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a06c8e"]])

export default __exports__